import { Button, type ButtonProps } from '@primer/react';
import type { ReactNode, CSSProperties, ButtonHTMLAttributes } from 'react';
import Spinner from '../progress/spinners/spinner';
import type { ButtonColorProps } from './types';

interface Props {
  id?: string;
  spinning: boolean;
  disabled?: boolean;
  children: ReactNode;
  onClick: () => void;
  style?: CSSProperties;
  tabIndex?: number;
  theme?: ButtonColorProps;
  type?: ButtonHTMLAttributes<any>['type'];
  variant?: ButtonProps['variant'];
  size?: ButtonProps['size'];
  leadingVisual?: ButtonProps['leadingVisual'];
}

export const SpinnerButton = (props: Props) => {
  return (
    <Button
      tabIndex={props.tabIndex}
      id={props.id}
      disabled={props.disabled}
      style={props.style}
      size={props.size}
      onClick={() => {
        if (props.disabled || props.spinning) {
          return;
        }
        props.onClick();
      }}
      type={props.type}
      variant={props.variant}
      leadingVisual={props.spinning ? InlineSpinner : props.leadingVisual}
    >
      {props.children}
    </Button>
  );
};

const InlineSpinner = () => <Spinner size={20} />;
